import { LevelDefinition, validateLevelDefinition } from "@algoquest/schemas";
import type { LevelDefinition as LevelDefinitionType } from "@algoquest/schemas";

/**
 * A level, validated at the boundary (Master Spec §10): the game runtime
 * never trusts a raw object as a LevelDefinition without parsing it first,
 * whether it came from a hardcoded fixture (Phase 01), a bundled JSON file
 * (Phase 02+), or the API (Phase 09+).
 */
export interface LoadedLevel {
  definition: LevelDefinitionType;
}

export function loadLevel(raw: unknown): LoadedLevel {
  const definition = LevelDefinition.parse(raw);
  const crossFieldErrors = validateLevelDefinition(definition);
  if (crossFieldErrors.length > 0) {
    throw new Error(`Invalid level "${definition.id}": ${crossFieldErrors.join("; ")}`);
  }
  return { definition };
}
